import axios from "axios"
import * as dictionary from '../components/dictionary'
import { zipcodeMap } from '../components/zipcodeMap'
import { collegeMap } from "../components/collegeMap"
import { useState, useEffect, useRef } from "react"
import { ECSearchAside } from "../components/ECSearch/ECSearchAside"
import { ECCard } from "../components/ECSearch/ECCard"
import { useNavigate, useLocation } from "react-router"
import { useAuth } from "../modules/auth"
import { LoadingIndicator } from "../components/LoadingIndicator"
import { fullCollegeMap } from "../components/fullCollegeMap"

const ECSearchPage = (props) => {

  const location = useLocation()
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  //////// Set states of variables ////////
  const [ec, setEC] = useState<any>([])
  const [filteredEC, setFilteredEC] = useState<any>([])
  const [filteredResults, setFilteredResults] = useState(false)
  const [filteredResultsFull, setFilteredResultsFull] = useState<any>([])
  const [nameOptions, setNameOptions] = useState<any>([]);
  const [locationOptions, setLocationOptions] = useState<any>([]);
  const [collegeOptions, setCollegeOptions] = useState<any>([]);
  const [sortKey, setSortKey] = useState<any>('name')
  const [sortOrder, setSortOrder] = useState<any>('Ascending')
  const [allECPremiumInsights, setAllECPremiumInsights] = useState<any>([])
  const [guestClickShowOnlyInterest, setGuestClickShowOnlyInterest] = useState(false)
  const [onlyInterestsSelect, setOnlyInterestsSelect] = useState(false)
  const [onlyPremiumsSelect, setOnlyPremiumsSelect] = useState(false)
  const [loadingComplete, setLoadingComplete] = useState(false)
  const [advisorData, setAdvisorData] = useState<any>([])
  const [advisorECs, setAdvisorECs] = useState<any>([])
  const [costSelect, setCostSelect] = useState<any>(25000)
  const [keywordSelect, setKeywordSelect] = useState<any>([])

  const [showLength, setShowLength] = useState(50)

  //Filter states
  const [nameFilter, setNameFilter] = useState<any>((item) => {
    return item => item
  })
  const [typeFilter, setTypeFilter] = useState<any>((item) => {
    return item => item
  })
  const [collegeFilter, setCollegeFilter] = useState<any>((item) => {
    return item => item
  })
  const [interestAreaFilter, setInterestAreaFilter] = useState<any>((item) => {
    return item => item
  })
  const [majorFilter, setMajorFilter] = useState<any>((item) => {
    return item => item
  })
  const [careerFilter, setCareerFilter] = useState<any>((item) => {
    return item => item
  })
  const [formatFilter, setFormatFilter] = useState<any>((item) => {
    return item => item
  })
  const [dateFilter, setDateFilter] = useState<any>((item) => {
    return item => item
  })
  const [gradeFilter, setGradeFilter] = useState<any>((item) => {
    return item => item
  })
  const [schoolLevelFilter, setSchoolLevelFilter] = useState<any>((item) => {
    return item => item
  })
  const [ageFilter, setAgeFilter] = useState<any>((item) => {
    return item => item
  })
  const [costFilter, setCostFilter] = useState<any>((item) => {
    return item => item
  })
  const [locationFilter, setLocationFilter] = useState<any>((item) => {
    return item => item
  })
  const [impactFilter, setImpactFilter] = useState<any>((item) => {
    return item => item
  })
  const [showOnlyMyInterestsFilter, setShowOnlyMyInterestsFilter] = useState<any>((item) => {
    return item => item
  })
  const [showOnlyPremiumsFilter, setShowOnlyPremiumsFilter] = useState<any>((item) => {
    return item => item
  })
  const [appDueDateFilter, setAppDueDateFilter] = useState<any>((item) => {
    return item => item
  })
  const [keywordFilter, setKeywordFilter] = useState<any>((item) => { return item => item })

  const [filtersActive, setFiltersActive] = useState(0)

  useEffect(() => {

    const sampleInput = {};
    const individualFilters = [
      nameFilter,
      typeFilter,
      interestAreaFilter,
      impactFilter,
      showOnlyPremiumsFilter,
      collegeFilter,
      appDueDateFilter,
      keywordFilter,
      dateFilter,
      formatFilter,
      schoolLevelFilter,
      gradeFilter,
      ageFilter,
      locationFilter,
      // costFilter,
      showOnlyMyInterestsFilter,

      // majorFilter,
      // careerFilter,
    ];

    // const groupedFilters = [
    //   filteredEarlyAppOptions,
    //   filteredCommonApp,
    //   filteredCoalition,
    //   filteredIndividualApp,
    //   filteredConsidersInterest,
    // ];

    const isFilterActive = (filter) => filter(sampleInput) !== sampleInput;

    const activeIndividualFiltersCount = individualFilters.filter(isFilterActive)?.length || 0;
    // const isGroupedFilterActive = groupedFilters.some(isFilterActive) ? 1 : 0;
    // const countOfActive = activeIndividualFiltersCount + isGroupedFilterActive;
    const costSelectActive = costSelect !== 25000 ? 1 : 0
    const countOfActive = activeIndividualFiltersCount + costSelectActive

    setFiltersActive(countOfActive);


  }, [
    nameFilter,
    typeFilter,
    interestAreaFilter,
    impactFilter,
    showOnlyPremiumsFilter,
    collegeFilter,
    appDueDateFilter,
    keywordFilter,
    dateFilter,
    formatFilter,
    schoolLevelFilter,
    gradeFilter,
    ageFilter,
    locationFilter,
    costSelect,
    // costFilter,
    showOnlyMyInterestsFilter,

    // majorFilter,
    // careerFilter,
  ])

  //////// Functions and event handlers ////////
  const getNameOptions = (ec) => {
    let res: any = []
    ec.forEach((ec) => {
      res.push({ value: ec.name, label: ec.name })
    });
    setNameOptions(res)
  }

  const getLocations = async (filteredEC) => {

    // zip code is in string format!!
    // Pull each zipcode from the ec data
    let allLocations: any = []
    filteredEC.forEach((ec) => {
      if (ec.locations !== null) {
        ec.locations.map((loc) => allLocations.push(loc))
      }
    })

    //  Create a set of that data to hold an array of unique zipcodes
    allLocations = [...new Set(allLocations)]
    allLocations.sort((a, b) => a - b)

    // Initialize the array to set the location options to
    let res: any = []

    let cityStates: any = []

    // For each unique zipcode:
    allLocations.forEach(loc => {

      // Find an object in the zipcodeMap array matching the zipcode field
      const zipcodeFound = zipcodeMap.find((item) => item.zipcode == loc)

      // If the cityStates array doesn't already have that cityState, get the zipcodes associated with that location
      if (zipcodeFound && !cityStates.includes(zipcodeFound.cityState)) {

        cityStates.push(zipcodeFound.cityState)

        let groupedZips: any = []

        zipcodeMap.forEach((item) => {

          if (item.cityState == zipcodeFound.cityState) {
            groupedZips.push(item.zipcode)
          }
        })

        if (groupedZips && groupedZips.length > 0) {

          groupedZips = [...new Set(groupedZips)]

          res.push({ value: groupedZips, label: `${zipcodeFound.cityState}` })
        }

        else {
          res.push({ value: loc, label: `${zipcodeFound.cityState}` })
        }
        // res.push({ value: loc, label: `${zipcodeFound.cityState}` })
      }

      // If a result is not found, just return the string `loc`
      else if (!zipcodeFound) {
        res.push({ value: loc, label: loc })
      }

    });

    // Sort the location options alphabetically 
    res = res.sort((a, b) => a.label.localeCompare(b.label))

    setLocationOptions(res)
  }

  const getInsights = async () => {
    let res = await axios.get(`${dictionary.URL}/ec_insights/`)
    setAllECPremiumInsights(res.data)
  }

  const getECValid = async () => {
    let res = await axios.get(`${dictionary.URL}/ec_activity_valid/`)
    return res.data
  }

  const getData = async () => {

    // let ecCache: string | null = localStorage.getItem('dantech-ec')
    let ecCache: any = await dictionary.handleLocalStorageData('dantech-ec', getECValid)

    const getColleges = (collegeMap, ecData) => {
      let res: any = []
      collegeMap.forEach((col) => {

        let foundECSponsorCollegeID = ecData.find((item) => item.sponsorCollegeID != null && parseInt(col.id) == item.sponsorCollegeID)

        if (foundECSponsorCollegeID) {
          res.push({ value: col.id, label: col.name })
        }
      });

      res = res.sort((a, b) => a.label.localeCompare(b.label))

      setCollegeOptions(res)
    }

    const handleSetAdvisors = async () => {
      // let advisorCache: string | null = localStorage.getItem('dantech-advisors')

      const getAdvisorsData = async () => {
        let res = await axios.get(`${dictionary.URL}/advisor_profiles_connect_with/`);
        return res.data
      }

      let advisorCache: any = await dictionary.handleLocalStorageData('dantech-advisors', getAdvisorsData)

      let advisorECs: any = []
      advisorCache.map(advisor => {
        advisor.ecActivities.forEach(ecID => advisorECs.push(ecID))
      })

      setAdvisorData(advisorCache)
      setAdvisorECs([...new Set(advisorECs)])
    }

    await handleSetAdvisors()

    getColleges(fullCollegeMap, ecCache)
    setEC(ecCache)
    setFilteredEC(ecCache);
    setFilteredResults(true);
  }

  //////// useEffects ////////
  useEffect(() => {

    dictionary.updateTitleAndDescription(dictionary.pageRoutes.ecSearch)

    try {

      if (loadingComplete == true) {
        setLoadingComplete(false)
      }

      getData();
      getInsights();
      // getColleges(collegeMap);
    } catch (error) {

      console.log('Error running EC Search page fetch requests', error);
      throw error;

    } finally {
      setLoadingComplete(true)
    }
  }, [])

  useEffect(() => {
    if (ec.length > 0) {
      getNameOptions(ec);
      getLocations(ec);
      // updateCollegeOptions(filteredEC, collegeOptions)
    }
  }, [ec])

  useEffect(() => {
    const sortAndFilter = (nameFilter, typeFilter, collegeFilter, interestAreaFilter, majorFilter, careerFilter, formatFilter, appDueDateFilter, dateFilter, gradeFilter, ageFilter, costFilter, locationFilter, impactFilter, schoolLevelFilter, showOnlyPremiumsFilter, sortOrder, sortKey, keywordFilter) => {

      if (onlyInterestsSelect == true && (!currentUser || !props.user)) {
        return setGuestClickShowOnlyInterest(true)
      }

      else {
        setGuestClickShowOnlyInterest(false)
      }

      let res: any = ec

      // No Date Filter set, need to update components
      res = res.filter(nameFilter).filter(typeFilter).filter(collegeFilter).filter(interestAreaFilter).filter(formatFilter).filter(gradeFilter).filter(ageFilter).filter(locationFilter).filter(costFilter).filter(dateFilter).filter(schoolLevelFilter).filter(impactFilter).filter(showOnlyMyInterestsFilter).filter(showOnlyPremiumsFilter).filter(appDueDateFilter).filter(keywordFilter)

      // res = res.filter(dateFilter).filter(majorFilter).filter(careerFilter);

      if (res.length === 0) {
        return setFilteredResults(false)
      }

      setFilteredResultsFull(res)

      sortOrder === 'Descending' ?
        res = res.sort((a, b) => dictionary.sortLogic(b, a, sortKey, 'name')) :
        res = res.sort((a, b) => dictionary.sortLogic(a, b, sortKey, 'name'))

      let filteredAndSorted = res.slice()
      filteredAndSorted = filteredAndSorted.splice(0, showLength)
      setFilteredEC(filteredAndSorted)

      if (filteredResults === false) {
        setFilteredResults(true)
      }
    }

    sortAndFilter(nameFilter, typeFilter, collegeFilter, interestAreaFilter, majorFilter, careerFilter, formatFilter, appDueDateFilter, dateFilter, gradeFilter, ageFilter, costFilter, locationFilter, impactFilter, schoolLevelFilter, showOnlyPremiumsFilter, sortOrder, sortKey, keywordFilter);

  }, [showOnlyPremiumsFilter, showOnlyMyInterestsFilter, nameFilter, typeFilter, collegeFilter, interestAreaFilter, majorFilter, careerFilter, formatFilter, appDueDateFilter, dateFilter, gradeFilter, ageFilter, costFilter, locationFilter, impactFilter, schoolLevelFilter, sortOrder, sortKey, showLength, keywordFilter])

  const returnResults = (filteredResults, guestClickShowOnlyInterest, onlyInterestsSelect, ec, loadingComplete) => {

    if (loadingComplete == false) {
      return (
        <div>
          {/* Use Bootstrap d-md-block to render while 768px or above */}
          <div className='d-none d-md-flex flex-column justify-content-start align-items-center'>
            <LoadingIndicator text={"Loading Information On Extracurricular Activities..."} />
          </div>

          {/* Mobile Replacement, only shows at below 768px */}
          <div className='d-flex d-md-none flex-column justify-content-center align-items-center'>
            <LoadingIndicator text={"Loading Information On Extracurricular Activities..."} mt={'60px'} ml={'0px'} />
          </div>
        </div>
      )
    }

    else {
      switch (true) {
        case (onlyInterestsSelect === true && ec.filter(showOnlyMyInterestsFilter).length === 0 && !filteredResults):
          return <div className="d-flex flex-column justify-content-center align-items-center" style={{ width: '1129px', maxWidth: '1129px' }}>
            <div className='mt-5'>Please save activities to your interest list in order for them to appear here.</div>
          </div>
        case guestClickShowOnlyInterest:
          return <div className="d-flex flex-column align-items-center" style={{ width: '1129px', maxWidth: '1129px' }}>
            <div style={{ marginTop: '180px' }}>Please first log-in to your account in order for your saved activities to appear here.</div>
          </div>
        case filteredResults:
          return <ECCard
            filteredEC={filteredEC}
            filtersActive={filtersActive}
            sortKey={sortKey}
            setSortKey={setSortKey}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            user={props.user}
            setUser={props.setUser}
            setNavigateTo={props.setNavigateTo}
            setECName={props.setECName}
            setECNumAlumni={props.setECNumAlumni}
            setECID={props.setECID}
            setPurchaseID={props.setPurchaseID}
            allECPremiumInsights={allECPremiumInsights}
            setShowNavAfterPayment={props.setShowNavAfterPayment}
            setPrompt={props.setPrompt}
            advisorECs={advisorECs}
            showLength={showLength}
            setShowLength={setShowLength}
            filteredResultsFull={filteredResultsFull}
          />
        case !filteredResults && ec && ec.length > 0:
          return <div
            className="d-flex flex-column align-items-center"
            style={{ width: '1129px', maxWidth: '1129px' }}>
            <div style={{ marginTop: '180px' }}>No results meet your criteria</div>
          </div>
      }

    }

  }

  const initFiltersActive = useRef<boolean | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const keys = [
      'onlyPremiums', 'onlyInterests', 'activityName', 'type', 'interestAreas', 'impact', 'college', 'appDueDate', 'keyword', 'activityDates', 'format', 'schoolLevel', 'grade', 'age', 'location', 'maxCost'
    ];

    const hasAnyFilter = keys.some((key) => params.get(key) !== null);

    if (hasAnyFilter) {
      initFiltersActive.current = true;
    }
  }, []);

  const descriptionText = initFiltersActive.current
    ? `initial results based on your preferences and explore further with additional filters.`
    : `a wide range of extracurricular activities and you may refine results using the filters.`;

  const descriptionTextMobile = initFiltersActive.current
    ? `See below for initial results based on your preferences and explore further with additional filters. Click any activity to see more details and use the Save button to add to your extracurriculars interest list.` : `See below for a wide range of extracurricular activities and you may refine results using the filters. Click any activity to see more details and use the Save button to add to your extracurriculars interest list.`;

  const ECSearchHeader = props.navFromDashboard.ec == true ? (
    <div className="dca-search-header-wrapper">
      <div className="d-flex justify-content-center">
        <span className='dca-search-title align-self-center'>Extracurriculars Explorer</span>
      </div>

      <span className="dca-search-description  dashboard" style={{ justifyContent: 'center', textAlign: 'center' }}>See below for {descriptionText} Click any activity to see more details and use the Save button to add to your extracurriculars interest list.</span>

    </div>
  ) : (
    <div className="dca-search-header-wrapper">
      <div className="dca-search-header-title-button-container">
        <span className='dca-search-title align-self-center'>Explore Extracurriculars</span>

        <div className="dca-search-header-bttn-container-double">
          <button
            type="button"
            aria-pressed="true"
            onClick={() => navigate(dictionary.pageRoutes.overviewAdmissionsAdviceWithHash('crafting-an-extracurriculars-profile'))}
            className='dca-search-header-bttn'
          >Advice: Selecting Extracurriculars</button>
          <button
            type="button"
            aria-pressed="true"
            onClick={() => navigate(dictionary.pageRoutes.personalizedExpertHelp)}
            className='dca-search-header-bttn'
            style={{ marginLeft: '8px' }}
          >Get Personalized Help{props.prevPurchaseCount === undefined && ` (Free!)`}</button>
        </div>
      </div>

      <span className="dca-search-description">Discover extracurricular activities that align with your personal interests and strengthen your application profile.</span>
    </div>
  )

  const ECSearchHeaderMobile = (
    <div className="dca-search-header-wrapper">
      <div className="dca-search-header-title-button-container">
        <span className='dca-search-title align-self-center'>{props.navFromDashboard.ec == true ? `Extracurriculars Explorer` : `Explore Extracurriculars`}</span>

        <span className="dca-search-description">{props.navFromDashboard.ec == true ? descriptionTextMobile : `Discover extracurricular activities that align with your personal interests and strengthen your application profile.`}</span>

        <ECSearchAside
          filteredEC={filteredEC}
          setFilteredEC={setFilteredEC}
          nameOptions={nameOptions}
          locationOptions={locationOptions}
          collegeOptions={collegeOptions}
          setNameFilter={setNameFilter}
          setTypeFilter={setTypeFilter}
          setCollegeFilter={setCollegeFilter}
          setInterestAreaFilter={setInterestAreaFilter}
          setMajorFilter={setMajorFilter}
          setCareerFilter={setCareerFilter}
          setFormatFilter={setFormatFilter}
          setDateFilter={setDateFilter}
          setGradeFilter={setGradeFilter}
          setAgeFilter={setAgeFilter}
          setCostFilter={setCostFilter}
          setLocationFilter={setLocationFilter}
          setImpactFilter={setImpactFilter}
          setSchoolLevelFilter={setSchoolLevelFilter}
          setAppDueDateFilter={setAppDueDateFilter}
          ecSearchLocation={props.ecSearchLocation}
          setECSearchLocation={props.setECSearchLocation}
          sortKey={sortKey}
          sortOrder={sortOrder}
          setSortKey={setSortKey}
          setSortOrder={setSortOrder}
          setShowOnlyMyInterestsFilter={setShowOnlyMyInterestsFilter}
          onlyInterestsSelect={onlyInterestsSelect}
          setOnlyInterestsSelect={setOnlyInterestsSelect}
          setShowOnlyPremiumsFilter={setShowOnlyPremiumsFilter}
          onlyPremiumsSelect={onlyPremiumsSelect}
          setOnlyPremiumsSelect={setOnlyPremiumsSelect}
          allECPremiumInsights={allECPremiumInsights}
          filtersActive={filtersActive}
          mobile={true}
          costSelect={costSelect}
          setCostSelect={setCostSelect}
          showLength={showLength}
          setShowLength={setShowLength}
          filteredResultsFull={filteredResultsFull}
          keywordSelect={keywordSelect}
          setKeywordSelect={setKeywordSelect}
          keywordFilter={keywordFilter}
          setKeywordFilter={setKeywordFilter}
        />

        <div>
          <div className='dca-college-search-resources-links-header'>RESOURCES</div>
          <div
            className='dca-college-search-resources-links'
            onClick={() => navigate(dictionary.pageRoutes.overviewAdmissionsAdviceWithHash('crafting-an-extracurriculars-profile'))}
          >Advice: Selecting Extracurriculars</div>
          <div
            className='dca-college-search-resources-links'
            onClick={() => navigate(dictionary.pageRoutes.personalizedExpertHelp)}
          >Get Personalized Help{props.prevPurchaseCount === undefined && ` (Free!)`}</div>
        </div>
      </div>
    </div>
  )

  return (
    <div id='dca-college-search-wrapper'>
      {/* Use Bootstrap d-md-block to render while 768px or above */}
      <div className='d-none d-md-flex'>
        {ECSearchHeader}
      </div>

      {/* Mobile Replacement, only shows at below 768px */}
      <div className='d-flex d-md-none'>
        {ECSearchHeaderMobile}
      </div>

      {/* Use Bootstrap d-md-block to render while 768px or above */}
      <div className='d-none d-md-flex'>
        <div className='mt-5 d-flex flex-row' style={{ marginLeft: '35px', marginRight: '35px', width: '100%' }}>
          <ECSearchAside
            filteredEC={filteredEC}
            setFilteredEC={setFilteredEC}
            nameOptions={nameOptions}
            locationOptions={locationOptions}
            collegeOptions={collegeOptions}
            setNameFilter={setNameFilter}
            setTypeFilter={setTypeFilter}
            setCollegeFilter={setCollegeFilter}
            setInterestAreaFilter={setInterestAreaFilter}
            setMajorFilter={setMajorFilter}
            setCareerFilter={setCareerFilter}
            setFormatFilter={setFormatFilter}
            setDateFilter={setDateFilter}
            setGradeFilter={setGradeFilter}
            setAgeFilter={setAgeFilter}
            setCostFilter={setCostFilter}
            setLocationFilter={setLocationFilter}
            setImpactFilter={setImpactFilter}
            setSchoolLevelFilter={setSchoolLevelFilter}
            setAppDueDateFilter={setAppDueDateFilter}
            ecSearchLocation={props.ecSearchLocation}
            setECSearchLocation={props.setECSearchLocation}
            sortKey={sortKey}
            sortOrder={sortOrder}
            setSortKey={setSortKey}
            setSortOrder={setSortOrder}
            setShowOnlyMyInterestsFilter={setShowOnlyMyInterestsFilter}
            onlyInterestsSelect={onlyInterestsSelect}
            setOnlyInterestsSelect={setOnlyInterestsSelect}
            setShowOnlyPremiumsFilter={setShowOnlyPremiumsFilter}
            onlyPremiumsSelect={onlyPremiumsSelect}
            setOnlyPremiumsSelect={setOnlyPremiumsSelect}
            allECPremiumInsights={allECPremiumInsights}
            filtersActive={filtersActive}
            costSelect={costSelect}
            setCostSelect={setCostSelect}
            showLength={showLength}
            setShowLength={setShowLength}
            filteredResultsFull={filteredResultsFull}
            keywordSelect={keywordSelect}
            setKeywordSelect={setKeywordSelect}
            keywordFilter={keywordFilter}
            setKeywordFilter={setKeywordFilter}
          />
          {returnResults(filteredResults, guestClickShowOnlyInterest, onlyInterestsSelect, ec, loadingComplete)}
        </div>
      </div>

      {/* Mobile Replacement, only shows at below 768px */}
      <div className='d-flex d-md-none justify-content-center'>
        {returnResults(filteredResults, guestClickShowOnlyInterest, onlyInterestsSelect, ec, loadingComplete)}
      </div>
    </div>
  )
}

export { ECSearchPage }